import { NavigationError } from '@angular/router';

// Browsers word a failed dynamic import differently.
const CHUNK_LOAD_ERROR = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError|Loading chunk [\w-]+ failed/i;
const LAST_RELOAD_KEY = 'chunk-reload-at';
// One reload per minute at most, so a chunk that is really missing cannot loop.
const RELOAD_COOLDOWN_MS = 60_000;

export const isChunkLoadError = (error: unknown): boolean =>
    CHUNK_LOAD_ERROR.test(String((error as Error)?.message ?? error));

/**
 * After a deploy, a tab that is still open asks for lazy chunks that the new
 * release no longer has. Hosting rewrites the miss to index.html, the import
 * fails, and the navigation dies. Load the target URL fresh instead, which
 * picks up the new index.html and its chunks.
 */
export function reloadOnChunkLoadError(e: NavigationError): void {
    if (!isChunkLoadError(e.error)) return;

    let last = 0;
    try { last = Number(sessionStorage.getItem(LAST_RELOAD_KEY)) || 0; } catch { /* storage blocked */ }
    if (Date.now() - last < RELOAD_COOLDOWN_MS) return;
    try { sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now())); } catch { /* storage blocked */ }

    window.location.assign(e.url);
}
